"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionColumnApiImpl = void 0;
const ApiBase_1 = require("./ApiBase");
class ActionColumnApiImpl extends ApiBase_1.ApiBase {
    constructor(adaptable) {
        super(adaptable);
    }
    getActionColumns() {
        var _a;
        return (_a = this.getActionColumnOptions().actionColumns) !== null && _a !== void 0 ? _a : [];
    }
}
exports.ActionColumnApiImpl = ActionColumnApiImpl;
